export default "__VITE_ASSET__VFfOoo8L__"